<div class="table-responsive">
	<table class="table table-borderless">
		<thead>
			<tr>
				<ng-container *ngFor="let column of columnSettings">
					<th
						[class]="column.isSorted ? column.class + ' col-sortable ' : column.class"
						[ngClass]="column.isSorted ? getSortClasses(column.name) : ''"
						(click)="column.isSorted ? onSetSort(column.name) : null"
					>
						{{ translationPath + '.' + column.name | translate }}
					</th>
				</ng-container>

				<th class="col-actions" *ngIf="withActions && (actionPermission | hasPermission)"></th>
			</tr>
		</thead>
		<tbody>
			<tr
				*ngFor="let item of list?.items; let i = index"
				[class]="'table-row' + (selectedRow === i ? ' selected' : '')"
				(click)="selectRow(i)"
			>
				<ng-container *ngFor="let col of columnSettings">
					<td *ngIf="!col.isBoolean && !col.isSpecialColumn; else toggleItem" [class]="col.class">
						{{ item[col.name] }}
					</td>

					<ng-template #toggleItem>
						<td *ngIf="col.isSpecialColumn" class="specialcolumn">
							<ng-container
								*ngTemplateOutlet="SpecialColumnTreatement; context: { $implicit: item[col.name], colname: col }"
							></ng-container>
						</td>
						<td *ngIf="col.isBoolean" class="col-enable">
							<btn-toggle [isStatic]="true" [checked]="item[col.name]"> </btn-toggle>
						</td>
					</ng-template>
				</ng-container>

				<td class="col-actions" *ngIf="withActions && (actionPermission | hasPermission)">
					<datagrid-actions-dropdown [stopPropagation]="selectedRow === i ? true : false">
						<ng-container *ngTemplateOutlet="buttonActions; context: { $implicit: item }"></ng-container>
					</datagrid-actions-dropdown>
				</td>
			</tr>
			<tr *ngIf="list?.items.length === 0" datagrid-row-empty [colspan]="12"></tr>
		</tbody>
	</table>
</div>

<datagrid-paging *ngIf="withPagination" [datagridHandler]="datagridHandler" [list]="list" [settings]="settings"> </datagrid-paging>
